import styles from './UserSectionSkeleton.module.css'
import {SkeletonBox, SkeletonText} from '@primer/react/experimental'

type Props = {
  placeholderRows?: number
}

/** Loading skeleton that mirrors user sections */
export function UserSectionSkeleton({placeholderRows = 3}: Props) {
  return (
    <ul className={styles.list}>
      {Array.from({length: placeholderRows}, (_, i) => (
        <li key={i} className={styles.row}>
          <SkeletonBox className={styles.avatar} />
          <SkeletonText size="bodySmall" className={styles.name} />
          <SkeletonBox className={styles.indicator} />
        </li>
      ))}
    </ul>
  )
}
